import React from "react";
import EAButton from "../../../shared/Buttons/EAButton";
import { useTranslation } from "react-i18next";
import ChangeTermButton from "../../../shared/Buttons/ChangeTermButton";
import { Ticket } from "../../../../models/Ticket";

interface IProps {
  ticketName: string;
  onSetOpenChangeDate: () => void;
  onSetOpenQrModal: () => void;
  ticket: Ticket;
  exerciseStartTime?: Date;
}

const SingleFutureTicketActions: React.FC<IProps> = ({
  ticketName,
  onSetOpenChangeDate,
  onSetOpenQrModal,
  ticket,
  exerciseStartTime,
}) => {
  const { t } = useTranslation();

  return (
    <div className="single-future-ticket-actions">
      <ChangeTermButton
        ticketName={ticketName}
        onClick={onSetOpenChangeDate}
        variant="outlined"
        checkIfNotReservation={true}
        checkAllowToChangeDate={true}
        checkIsExerciseSelfService={true}
        ticket={ticket}
        exerciseStartTime={exerciseStartTime}
        checkTimeBeforeExercise={!!exerciseStartTime}
      />
      <EAButton title={t("pokaz_kod_qr")} onClick={onSetOpenQrModal} />
    </div>
  );
};

export default SingleFutureTicketActions;
